import { Controller } from "@hotwired/stimulus"
import { showKitUsedWarning } from "../../src/kit_used_warning"

export default class extends Controller {
  static values = {
    timepointStorageTag: String,
    allowPreVisitCollectionDate: String,
    kitUsedInfoUrl: String,
  }
  static get targets() {
    return [
      "timeField",
      "kitRegistrationNumber",
      "kitUsedWarning",
    ]
  }

  connect(){
    this.setTimepointTime()
    window.initializeTimepickers()
    $(".datepicker").datepicker();
    this.bindCollectionFieldValidation()

    document.addEventListener("turbo:frame-missing", (event) => {
      const { detail: { response, visit } } = event;
      event.preventDefault();
      visit(response.url);
    });

    $('input[type="number"]').each((index,field)=>{
      $(field).inputSpinner()
    })

    $(".timepicker").timepicker({
      showMeridian: false,
      showSeconds: true,
      minuteStep: 10,
      secondStep: 10,
      icons: {
      up: "fas fa-chevron-up",
      down: "fas fa-chevron-down",
      },
    });
  }

  checkCollectionDate(e) {
    let collection_date = e.target.value.toLowerCase();
    let visit_date = e.target.getAttribute("data-visit-date").toLowerCase();
    if (collection_date === "") {
      this.hideDateAlerts();
    } else if (this.allowPreVisitCollectionDateValue == "false" && collection_date < visit_date) {
      $('.pre-visit-date-alert').removeClass('d-none');
      $('.date-mismatch-alert').addClass('d-none');
    } else if (collection_date !== visit_date) {
      $('.date-mismatch-alert').removeClass('d-none');
      $('.pre-visit-date-alert').addClass('d-none');
    } else {
      this.hideDateAlerts();
    }
  }

  hideDateAlerts() {
    $('.pre-visit-date-alert').addClass('d-none');
    $('.date-mismatch-alert').addClass('d-none');
  }

  toggleCollapseIcon(e){
    var step_id = e.target.getAttribute("data-step-id")
    $(`#toggle-icon-${step_id}`).toggleClass('fa-chevron-up');
    $(`#toggle-icon-${step_id}`).toggleClass('fa-chevron-down');
  }

  toggleConsentModalTrigger(e) {
    // switch the normal Mark Complete button with a lookalike that triggers the modal 
    // if the user selected the No radio button >:)
    if($(e.target).prop('checked') && $(e.target).val() == 2) {
      $(".consent-complete").addClass("d-none");
      $(".consent-modal").removeClass("d-none");
    } else {
      $(".consent-complete").removeClass("d-none");
      $(".consent-modal").addClass("d-none");
    }
  }

  toggleProcedureCollectedStatus(event){
    $(".procedure-not-collected-select").on('change', function(e){
      var timepoint_id = e.target.getAttribute("data-timepoint-id")
      var step_id = e.target.getAttribute("data-step-id")
      if($(e.target).prop('checked')){
        $(e.target).closest(".procedure-step").find(".notes-container").removeClass("d-none");
        $(e.target).closest(".procedure-step").find(".notes-field").attr("disabled", false)
        $(`#collection_date_${step_id}`).removeClass("d-none");
        $(`#step_time_${step_id}`).removeClass("d-none");
        $(`#step_time_${step_id}`).prop('required', true);
        $(`label[for='timepoint_${timepoint_id}_collection_status']`).text("Collected")
        $('.collection-not-collected-reason').addClass('d-none');
        $('#reason-not-collected-select').prop('required', false);
        $('.time-label').removeClass('d-none');
        $('.date-label').removeClass('d-none');
        $('.time-zone-indicator').removeClass('d-none');

        $(".not-collected-select").each(function(i) {
          $(this).prop("checked", true)
          $(`label[for='${$(this).attr("name")}']`).text("Collected")
        })

        $(`.autocomplete-barcode-field`).attr("disabled", false);
        $(`.autocomplete-barcode-field`).attr("placeholder", "Scan or type");

        $(`.timepoint-meta-field[data-timepoint-id='${timepoint_id}']`).attr("disabled", false);

        $(".mark-complete").each(function(i) {
          if ($(this).prop("disabled")) {
            $(this).removeClass("d-none")
          }
        })
      } else {
        $(e.target).closest(".procedure-step").find(".notes-container").addClass("d-none");
        $(e.target).closest(".procedure-step").find(".notes-field").attr("disabled", true)
        $(`#collection_date_${step_id}`).addClass("d-none");
        $(`#step_time_${step_id}`).addClass("d-none");
        $(`#step_time_${step_id}`).prop('required', false);
        $(`label[for='timepoint_${timepoint_id}_collection_status']`).text("Not collected")
        $('.collection-not-collected-reason').removeClass('d-none');
        $('#reason-not-collected-select').prop('required', true);
        $('.time-label').addClass('d-none');
        $('.date-label').addClass('d-none');
        $('.time-zone-indicator').addClass('d-none');

        $(".not-collected-select").each(function(i) {
          $(this).prop("checked", false)
          $(`label[for='${$(this).attr("name")}']`).text("Not collected")
        })

        $(`.autocomplete-barcode-field`).attr("disabled", true);
        $(`.autocomplete-barcode-field`).attr("placeholder", "Not Collected");
        $(`.autocomplete-barcode-field`).val("");

        $(".mark-complete").each(function(i) {
          if ($(this).prop("disabled")) {
            $(this).addClass("d-none")
          }
        })
      }
    });
  }

  bindCollectionFieldValidation() {
    const root = this.element.closest(".procedure-step")
    if (this.element !== root || !root.querySelector("[data-collection-complete-wrapper]")) return

    const validate = () => this.validateCollectionFields()
    $(root).find(".collection-date, .slsm-timepoint-timepicker")
      .on("input change changeDate changeTime.timepicker", validate)
    $(root).find(".procedure-not-collected-select").on("change", validate)

    $(root).find("[data-collection-complete-wrapper]").tooltip()
    validate()
  }

  validateCollectionFields() {
    const root = this.element.closest(".procedure-step")
    const wrapper = root.querySelector("[data-collection-complete-wrapper]")
    const dateField = root.querySelector(".collection-date")
    if (!wrapper || !dateField) return

    const notCollectedToggle = root.querySelector(".procedure-not-collected-select")
    const collected = !notCollectedToggle || notCollectedToggle.checked
    const timeMissing = this.hasTimeFieldTarget && !this.timeFieldTarget.value.trim()
    const missing = collected && (!dateField.value.trim() || timeMissing)

    const buttons = $(wrapper).find(".mark-complete").add($(root).find(".collection-mark-complete"))
    buttons.filter("input, button").prop("disabled", missing)
    buttons.filter("a").toggleClass("disabled", missing).attr("aria-disabled", missing)
    $(wrapper).tooltip(missing ? "enable" : "disable")
  }

  storeTimepointTime(event){
    var tag = this.timepointStorageTagValue
    if (this.hasTimeFieldTarget){
      var time = this.timeFieldTarget.value
      localStorage.setItem(tag, time)
    }
  }

  setTimepointTime(event){
    var tag = this.timepointStorageTagValue
    var suggested_time = localStorage.getItem(tag)
    if (this.element.querySelector(".collection-date")) return
    if (suggested_time !== null && this.hasTimeFieldTarget && this.timeFieldTarget.value == ""){
      this.timeFieldTarget.value = suggested_time
    }
  }

  // Dispatched by the kit registration dropdown once a kit has been chosen.
  async kitSelected(event) {
    const { id, number, alreadyUsed } = event.detail;

    this.kitRegistrationNumberTarget.value = id;

    await showKitUsedWarning(this.hasKitUsedWarningTarget ? this.kitUsedWarningTarget : null, {
      alreadyUsed, selectedId: id, selectedNumber: number, url: this.kitUsedInfoUrlValue,
    });
  }

  destroyTooltip() {
    $('[data-toggle="tooltip"]').tooltip('dispose')
  }
}
